export function trackEvent(category: string, action: string) {
  let pagePath = window.location.pathname;
  let queue = (window as any)._paq;
  if (queue && queue.push) {
    queue.push(["trackEvent", category, action, pagePath]);
  }
}
